import { DailyAgendaState } from './types';

export const initialStateFactory = (): DailyAgendaState => ({
  counter: 1,
  name: '',
});
